import React from "react";
import Header from "../Header";
import Footer from "../Footer";

export default function Page({ children }: { children: React.ReactNode }) {
  return (
    <div className="page-layout">
      <Header />
      <div className="children-area">{children}</div>
      <Footer />
    </div>
  );
}
